/**
 * Clears user-specific preferences from localStorage on logout
 * This ensures personal data doesn't persist for the next user on shared devices
 */
export const clearUserPreferences = () => {
  // Clear favorites and hidden preferences
  localStorage.removeItem('hiddenLivings')
  localStorage.removeItem('favoriteReports') 
  localStorage.removeItem('favoriteProductReports')
  
  // Add any other user-specific preferences here as needed
}